<template>
  <section>
    <h2>
      <p class="en">Recommend Plans</p>
      <p class="ja">おすすめプラン</p>
    </h2>

    <ul class="search-result">
      <li
        v-for="(item, index) in recommendItems"
        :key="item.id"
      >
        <div class="thumb">
          <mq-layout mq="pc">
            <img :src="item.recommendImageWide" @click="openModal(index)">
          </mq-layout>
          <mq-layout mq="tb">
            <img :src="item.recommendImageMin" @click="openModal(index)">
          </mq-layout>
          <div class="label">
            <div class="outline" @click="openModal(index)">
              <div>
                <p class="type"><span v-for="(item, index) in item.type" :key="index">{{ item }}</span>type</p>
                <p class="gradeType"><span>{{ item.gradeType }}</span>グレード</p>
                <p class="grade" v-if="item.hasPackage"><span v-for="(item, index) in item.grade" :key="index">{{ item }}</span>パッケージ</p>
                <!-- <p class="size" v-for="(item, index) in item.size" :key="index">{{ item }}</p> -->
              </div>
            </div>
          </div>
        </div>
        <transition name="fade">
          <div class="modal" v-if="item.modal">
            <div class="filter" @click="closeModal(index)"></div>
              <mq-layout mq="pc">
                <div class="content">
                  <div class="thumbnail">
                    <img :src="item.thumbnail">
                    <div>
                      <div>
                        <p class="type"><span v-for="(item, index) in item.type" :key="index">{{ item }}</span>type</p>
                        <p class="gradeType"><span>{{ item.gradeType }}</span>グレード</p>
                        <p class="grade" v-if="item.hasPackage"><span v-for="(item, index) in item.grade" :key="index">{{ item }}</span>パッケージ</p>
                        <!-- <p class="size" v-for="(item, index) in item.size" :key="index">{{ item }}</p> -->
                      </div>
                    </div>
                  </div>
                  <div class="spec">
                    <div class="list">
                      <dl>
                        <dt>床色</dt>
                        <dd>{{ item.floorColor }}</dd>
                      </dl>
                      <dl>
                        <dt>アクセント壁色</dt>
                        <dd>{{ item.wallColor }}</dd>
                      </dl>
                      <dl>
                        <dt>周囲壁</dt>
                        <dd>{{ item.surroundingWall }}</dd>
                      </dl>
                      <dl>
                        <dt>天井色</dt>
                        <dd>{{ item.ceilingColor }}</dd>
                      </dl>
                      <dl>
                        <dt>換気扇・乾燥機種</dt>
                        <dd>{{ item.ventilation }}</dd>
                      </dl>
                      <dl>
                        <dt>ドア種</dt>
                        <dd>{{ item.doorType }}</dd>
                      </dl>
                      <dl>
                        <dt>浴槽形状</dt>
                        <dd>{{ item.bathtubShape }}</dd>
                      </dl>
                      <dl>
                        <dt>浴槽材質</dt>
                        <dd>{{ item.bathtubMaterial }}</dd>
                      </dl>
                      <dl>
                        <dt>浴槽色</dt>
                        <dd>{{ item.bathtubColor }}</dd>
                      </dl>
                      <dl>
                        <dt>エプロン色・カウンター色</dt>
                        <dd>{{ item.apronColor }}・{{ item.counterColor }}</dd>
                      </dl>
                      <dl>
                        <dt>水栓金具・洗場水栓</dt>
                        <dd>{{ item.waterPanel }}</dd>
                      </dl>
                      <dl>
                        <dt>シャワー種</dt>
                        <dd>{{ item.showerType }}</dd>
                      </dl>
                      <dl>
                        <dt>鏡</dt>
                        <dd>{{ item.mirrorType }}</dd>
                      </dl>
                      <dl>
                        <dt>照明</dt>
                        <dd>{{ item.lightingType }}</dd>
                      </dl>
                      <dl>
                        <dt>手摺</dt>
                        <dd>{{ item.handrail }}</dd>
                      </dl>
                      <dl>
                        <dt>浴槽横手摺</dt>
                        <dd>{{ item.sideHandrail }}</dd>
                      </dl>
                      <dl>
                        <dt>ドア横縦手摺</dt>
                        <dd>{{ item.doorHandrail }}</dd>
                      </dl>
                      <dl>
                        <dt>タオル掛け</dt>
                        <dd>{{ item.towel }}</dd>
                      </dl>
                      <dl>
                        <dt>収納棚種</dt>
                        <dd>{{ item.rackType }}</dd>
                      </dl>
                      <dl>
                        <dt>風呂蓋</dt>
                        <dd>{{ item.bathtubLid }}</dd>
                      </dl>
                      <dl>
                        <dt>その他</dt>
                        <dd>{{ item.other }}</dd>
                      </dl>
                    </div>
                    <div class="notation">
                      <!-- <dl class="nomal">
                        <dt>本体価格（基本仕様）</dt>
                        <dd>
                          <template v-if="item.basicSize"><span class="another">{{ item.basicSize }}</span></template>
                          <span>{{ item.basicPrice }}</span>
                          <template v-if="item.anotherSize">
                            <br>
                            <span class="another">{{ item.anotherSize }}</span>
                            <span>{{ item.anotherBasicPrice }}</span>
                          </template>
                          <template v-if="item.anotherSize2">
                            <br>
                            <span class="another">{{ item.anotherSize2 }}</span>
                            <span>{{ item.anotherBasicPrice2 }}</span>
                          </template>
                        </dd>
                      </dl>
                      <dl class="option">
                        <dt>オプション価格</dt>
                        <dd><span>{{ item.optionPrice }}</span></dd>
                      </dl>
                      <dl class="option">
                        <dt>本体＋オプション価格</dt>
                        <dd>
                          <template v-if="item.basicSize"><span class="another">{{ item.basicSize }}</span></template>
                          <span>{{ item.totalPrice }}</span>
                          <template v-if="item.anotherSize">
                            <br>
                            <span class="another">{{ item.anotherSize }}</span>
                            <span>{{ item.anotherTotalPrice }}</span>
                          </template>
                          <template v-if="item.anotherSize2">
                            <br>
                            <span class="another">{{ item.anotherSize2 }}</span>
                            <span>{{ item.anotherTotalPrice2 }}</span>
                          </template>
                        </dd>
                      </dl> -->
                      <p class="addition"><template v-if="item.anotherSize">＊ 画像は1616</template></p>
                    </div>
                    <div class="close is-pc" @click="closeModal(index)">
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                  <div class="close is-tb" @click="closeModal(index)">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </mq-layout>
              <mq-layout mq="tb">
                <div class="content">
                  <swiper-layout
                    class="with-sider swiper-layout-sliderecommend"
                  >
                    <swiper-slide>
                      <div class="thumbnail">
                        <img :src="item.thumbnail">
                        <div>
                          <div>
                            <p class="type"><span v-for="(item, index) in item.type" :key="index">{{ item }}</span>type</p>
                            <p class="gradeType"><span>{{ item.gradeType }}</span>グレード</p>
                            <p class="grade" v-if="item.hasPackage"><span v-for="(item, index) in item.grade" :key="index">{{ item }}</span>パッケージ</p>
                            <!-- <p class="size" v-for="(item, index) in item.size" :key="index">{{ item }}</p> -->
                          </div>
                        </div>
                      </div>
                    </swiper-slide>
                    <swiper-slide>
                      <div class="spec">
                        <div class="list slide_recommend">
                          <dl>
                            <dt>床色</dt>
                            <dd>{{ item.floorColor }}</dd>
                          </dl>
                          <dl>
                            <dt>アクセント壁色</dt>
                            <dd>{{ item.wallColor }}</dd>
                          </dl>
                          <dl>
                            <dt>周囲壁</dt>
                            <dd>{{ item.surroundingWall }}</dd>
                          </dl>
                          <dl>
                            <dt>天井色</dt>
                            <dd>{{ item.ceilingColor }}</dd>
                          </dl>
                          <dl>
                            <dt>換気扇・乾燥機種</dt>
                            <dd>{{ item.ventilation }}</dd>
                          </dl>
                          <dl>
                            <dt>ドア種</dt>
                            <dd>{{ item.doorType }}</dd>
                          </dl>
                          <dl>
                            <dt>浴槽形状</dt>
                            <dd>{{ item.bathtubShape }}</dd>
                          </dl>
                          <dl>
                            <dt>浴槽材質</dt>
                            <dd>{{ item.bathtubMaterial }}</dd>
                          </dl>
                          <dl>
                            <dt>浴槽色</dt>
                            <dd>{{ item.bathtubColor }}</dd>
                          </dl>
                          <dl>
                            <dt>エプロン色・カウンター色</dt>
                            <dd>{{ item.apronColor }}・{{ item.counterColor }}</dd>
                          </dl>
                          <dl>
                            <dt>水栓金具・洗場水栓</dt>
                            <dd>{{ item.waterPanel }}</dd>
                          </dl>
                          <dl>
                            <dt>シャワー種</dt>
                            <dd>{{ item.showerType }}</dd>
                          </dl>
                          <dl>
                            <dt>鏡</dt>
                            <dd>{{ item.mirrorType }}</dd>
                          </dl>
                          <dl>
                            <dt>照明</dt>
                            <dd>{{ item.lightingType }}</dd>
                          </dl>
                          <dl>
                            <dt>手摺</dt>
                            <dd>{{ item.handrail }}</dd>
                          </dl>
                          <dl>
                            <dt>浴槽横手摺</dt>
                            <dd>{{ item.sideHandrail }}</dd>
                          </dl>
                          <dl>
                            <dt>ドア横縦手摺</dt>
                            <dd>{{ item.doorHandrail }}</dd>
                          </dl>
                          <dl>
                            <dt>タオル掛け</dt>
                            <dd>{{ item.towel }}</dd>
                          </dl>
                          <dl>
                            <dt>収納棚種</dt>
                            <dd>{{ item.rackType }}</dd>
                          </dl>
                          <dl>
                            <dt>風呂蓋</dt>
                            <dd>{{ item.bathtubLid }}</dd>
                          </dl>
                          <dl>
                            <dt>その他</dt>
                            <dd>{{ item.other }}</dd>
                          </dl>
                        </div>
                        <div class="notation">
                          <!-- <dl class="nomal">
                            <dt>本体価格（基本仕様）</dt>
                            <dd>
                              <template v-if="item.basicSize"><span class="another">{{ item.basicSize }}</span></template>
                              <span>{{ item.basicPrice }}</span>
                              <template v-if="item.anotherSize">
                                <br>
                                <span class="another">{{ item.anotherSize }}</span>
                                <span>{{ item.anotherBasicPrice }}</span>
                              </template>
                              <template v-if="item.anotherSize2">
                                <br>
                                <span class="another">{{ item.anotherSize2 }}</span>
                                <span>{{ item.anotherBasicPrice2 }}</span>
                              </template>
                            </dd>
                          </dl>
                          <dl class="option">
                            <dt>オプション価格</dt>
                            <dd><span>{{ item.optionPrice }}</span></dd>
                          </dl>
                          <dl class="option">
                            <dt>本体＋オプション価格</dt>
                            <dd>
                              <template v-if="item.basicSize"><span class="another">{{ item.basicSize }}</span></template>
                              <span>{{ item.totalPrice }}</span>
                              <template v-if="item.anotherSize">
                                <br>
                                <span class="another">{{ item.anotherSize }}</span>
                                <span>{{ item.anotherTotalPrice }}</span>
                              </template>
                              <template v-if="item.anotherSize2">
                                <br>
                                <span class="another">{{ item.anotherSize2 }}</span>
                                <span>{{ item.anotherTotalPrice2 }}</span>
                              </template>
                            </dd>
                          </dl> -->
                          <p class="addition"><template v-if="item.anotherSize">＊ 画像は1616</template></p>
                        </div>
                      </div>
                    </swiper-slide>
                  </swiper-layout>
                  <div class="close is-tb" @click="closeModal(index)">
                    <span></span>
                    <span></span>
                  </div>
                </div>
              </mq-layout>
          </div>
        </transition>
      </li>
    </ul>

    <div class="btn">
      <app-button path="/search" name="サイズ別にさらに詳しくみる"/>
    </div>
  </section>
</template>

<script>
import lodash from 'lodash';
import AppButton from '@/components/AppButton.vue';
import SwiperLayout from "@/components/globals/SwiperLayout.vue";

export default {
  name: 'SlideRecommend',
  components: {
    AppButton,
    SwiperLayout,
  },
  computed: {
    recommendItems() {
      return lodash.filter(this.$store.state.catalogList, 'recommend').sort((a, b) => {
        return (a.recommendIndex < b.recommendIndex) ? -1 : (a.recommendIndex > b.recommendIndex) ? 1 : 0;
      })
    }
  },
  methods: {
    // モーダルの開閉
    openModal(index) {
      this.recommendItems[index].modal = true;
    },
    closeModal(index) {
      this.recommendItems[index].modal = false;
    }
  }
}
</script>

<style scoped lang="scss">
section {
  background-image: url('/images/bg_recommend.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
}

h2 {
  color: #fff;
  text-align: center;
  padding: 64px 0;

  @include mq(tb) {
    padding: 32px 0;
  }

  .en {
    font-size: 36px;
    font-family: $bellFont;

    @include mq(tb) {
      font-size: 27px;
    }
  }

  .ja {
    font-size: 13px;
    margin-top: 20px;
  }
}

ul {
  display: flex;

  @include mq(tb) {
    flex-wrap: wrap;
    margin: 0 40px;
  }

  > li {
    width: calc(100% / 6);

    @include mq(tb) {
      width: calc(100% / 2);
    }

    img {
      width: 100%;
    }
  }

  .thumb {
    position: relative;
    cursor: pointer;

    &:hover {
      .label {
        opacity: 1;
      }
    }

    .label {
      opacity: 0;
      transition: $fastTransition;

      @include mq(tb) {
        opacity: 1;
      }
    }

    .outline {
      @include centering;
      @include flexCentering;
      background: $colorBeige;
      width: 12vw;
      height: 12vw;
      text-align: center;

      @include mq(tb) {
        width: 28vw;
        height: 28vw;
      }
    }

    p + p {
      margin-top: 14px;

      @include mq(tb) {
        margin-top: 6px;
      }
    }

    .type {
      font-family: $bellFont;
      font-size: 18px;

      @include mq(tb) {
        font-size: 13px;
      }

      span {
        font-size: 34px;
        margin-right: 2px;
        vertical-align: middle;

        @include mq(tb) {
          font-size: 27px;
        }
      }
    }

    .gradeType {
      font-weight: bold;
      font-size: 13px;

      @include mq(tb) {
        font-size: 10px;
      }

      span {
        font-family: $bellFont;
        font-size: 20px;
        margin-right: 5px;

        @include mq(tb) {
          font-size: 14px;
        }
      }
    }

    .grade {
      font-weight: bold;
      font-size: 11px;

      @include mq(tb) {
        font-size: 10px;
      }

      span {
        font-family: $bellFont;
        font-size: 15px;
        margin-right: 4px;

        @include mq(tb) {
          font-size: 12px;
        }
      }
    }

    .size {
      font-family: $bellFont;
      font-size: 27px;

      @include mq(tb) {
        font-size: 22px;
      }
    }
  }
}

.btn {
  width: $baseBtnSize;
  margin: 0 auto;
  padding: 32px 0;
}

.modal {
  @include catalogModal;

  .content .thumbnail > div .type {
    margin-bottom: 12px;

    @include mq(tb) {
      margin-bottom: 4px;
    }
  }

  .content .thumbnail > div .gradeType {
    margin-bottom: 14px;

    @include mq(tb) {
      margin-bottom: 4px;
    }
  }
}

.fade-enter-active, .fade-leave-active {
  opacity: 1;
  transition: $fastTransition;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

//20220401 仕様をセンタリングに
.modal .content .spec{
  display: flex;
  flex-direction: column;
  justify-content: center;

  .list{
    &.slide_recommend{
      @include mq(tb){
        margin: 0 16px;
        dt{
          width: 46%;
          margin-right: 8%;
        }
        dd{
          width: 46%;
        }
      }
    }
  }

  .notation{
    margin-top: 0;
    .addition{
      margin-top: 0;

      @include mq(tb) {
        margin-top: 16px;
      }
    }
  }

}

// tbサイズ以下の場合、カルーセル1個目のサムネと、
// 2個目のspecを縦方向にセンタリング
/deep/ .swiper-layout-sliderecommend{

    @include mq(tb) {
      .swiper-wrapper{
        display: flex;
        align-items: center;
      }

      .swiper-button-prev{
        transform: scale(50%, 50%);
        left: 2px;
      }
      .swiper-button-next {
        transform: scale(50%, 50%);
        right: 2px;
      }
    }
}

</style>
